export enum InstrumentosFinanceirosColumnType {
  CODIGO = 1,
  TIPO_INSTRUMENTO_FINANCEIRO = 2,
  RAZAO_EMISSOR = 3,
  VALOR_UNITARIO_EMISSAO = 9,
  QUANTIDADE = 10,
  CODIGO_PARTICIPANTE = 25,
}
